import React from 'react';
import { Link } from 'react-router-dom';
import * as api from '../../../api';
import * as textHelper from '../../../utils/TextHelper';
import * as itemHelper from '../../../utils/ItemsHelper';
import { ITEM_TYPE, ROUTING, PATH } from '../../../constants';
import './ListItem.css';

const getLink = (linkUrl, style, linkContent) => (
  <a
    className="list-item"
    style={style}
    href={linkUrl}
    target="_blank"
    rel="noopener noreferrer"
  >
    {linkContent}
  </a>
);

const ListItem = ({ grid, itemData }) => {
  const mainData = itemData[1];
  let route = '';
  let showDate = true;
  const look = itemHelper.getItemLook(mainData);

  // route
  switch (mainData.type) {
    case ITEM_TYPE.VIDEO:
    case ITEM_TYPE.MEMORY:
    case ITEM_TYPE.ARTICLE:
    case ITEM_TYPE.INFOGRAPHIC:
    case ITEM_TYPE.MAP:
    case ITEM_TYPE.VYSILANI:
      route = `${ROUTING.DETAIL}/${itemData[0]}`;
      break;
    case ITEM_TYPE.SCHOOL_SHEET:
      route = `${ROUTING.SCHOOL_DETAIL}/${mainData.id}`;
      break;
    case ITEM_TYPE.CATEGORY:
      route = `${ROUTING.CATEGORY}/${mainData.categoryId}`;
      break;
    case ITEM_TYPE.SPECIAL:
      if (mainData.link.type === 'link') {
        route = mainData.link.path;
      }
      break;
    default:
  }

  // todo - 3 switches are not ideal - maybe somehow merge into one
  // extra
  switch (mainData.type) {
    case ITEM_TYPE.SCHOOL_SHEET:
    case ITEM_TYPE.VYSILANI:
      showDate = false;
      break;
    default:
  }

  // title class
  let titleClass = 'title';
  if (mainData.title.length > 60) {
    titleClass = `${titleClass} longest`;
  } else if (mainData.title.length > 40) {
    titleClass = `${titleClass} long`;
  }

  // content
  const linkContent = (
    <div className="wrap">
      <div className="img-cont">
        <img
          className="thumb"
          src={look.imgUrl}
          alt={mainData.title}
        />
        {look.ico.length > 0 &&
        <img
          className="ico"
          src={`${PATH.IMG}ico/ico-${look.ico}.png`}
          alt="Otevřít"
        />
        }
      </div>
      {showDate &&
      <div className="date">{mainData.timeline}</div>
      }
      {mainData.channel &&
      <div className="date-time">
        {`${mainData.date} - ${mainData.time} ${mainData.channel}`}
      </div>
      }
      <div className={titleClass}>{textHelper.formatText(mainData.title)}</div>
    </div>
  );

  // size
  const style = {
    width: `${100 / grid}%`,
  };

  // link
  if (route.length > 0) {
    // todo - article ios hotfix - revise
    if (mainData.type === ITEM_TYPE.ARTICLE && api.isIOs()) {
      return getLink(mainData.link, style, linkContent);
    }
    return (
      <Link
        className="list-item"
        style={style}
        to={route}
      >
        {linkContent}
      </Link>
    );
  }
  // redirect
  return getLink(mainData.link.path, style, linkContent);
};

export default ListItem;



// WEBPACK FOOTER //
// ./src/components/App/ListItem/ListItem.js